<template>
  <!--签证变更-->
  <div class="cooperation-visa-detail-container">
    <cp-title
      title="变更概览"
      type="choose"
      @chooseAllOrMonth="chooseAllOrMonth"
    ></cp-title>
    <div class="visa-details-container">
      <template v-if="tabKey == '累计'">
        <div class="top">
          <div>
            <span>一单一估</span>
            <span>{{ body.adYdygvalue | money2 }}</span>
            <span>累计金额</span>
          </div>
          <div>
            <span></span>
            <span v-if="body.adYdygnumber !== '' || null"
              >{{ body.adYdygnumber }}&nbsp;份</span
            >
            <span v-if="body.adYdygnumber === '' || null">--</span>
            <span>累计份数</span>
          </div>
        </div>
        <div class="bottom">
          <div>
            <span>一单一结</span>
            <span>{{ body.adYdyjdeclareAmount | money2 }}</span>
            <span>申报金额</span>
          </div>
          <div>
            <span></span>
            <span>{{ body.adYdyjconfirmAmount | money2 }}</span>
            <span>确认金额</span>
          </div>
          <div>
            <span></span>
            <span v-if="body.adYdyjconfirmNumber !== '' || null"
              >{{ body.adYdyjconfirmNumber }}&nbsp;份</span
            >
            <span v-if="body.adYdyjconfirmNumber === '' || null">--</span>

            <span>确认份数</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="top">
          <div>
            <span>一单一估</span>
            <span>{{ body.cmYdygvalue | money2 }}</span>
            <span>本月金额</span>
          </div>
          <div>
            <span></span>
            <span>{{ body.cmYdygnumber }}&nbsp;份</span>
            <span>本月份数</span>
          </div>
        </div>
        <div class="bottom">
          <div>
            <span>一单一结</span>
            <span>{{ body.cmYdyjdeclareAmount | money2 }}</span>
            <span>申报金额</span>
          </div>
          <div>
            <span></span>
            <span>{{ body.cmYdyjconfirmAmount | money2 }}</span>
            <span>确认金额</span>
          </div>
          <div>
            <span></span>
            <span>{{ body.cmYdyjconfirmNumber }}&nbsp;份</span>
            <span>确认份数</span>
          </div>
        </div>
      </template>
    </div>
    <van-list
      :offset="30"
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="(item, index) in list" :key="index">
        <template>
          <visa-list :item="item"></visa-list>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import cpTitle from '../../components/title-cp';
import visaList from './components/cooperation-visa-detail-list';
import { Sticky, List, PullRefresh } from 'vant';
import { getUrlParams } from 'common/js/mUtils';

export default {
  components: {
    cpTitle,
    visaList,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  name: 'cooperation-visa-detail',

  data() {
    return {
      testData: [1, 2, 3, 4, 5, 6],
      body: {},
      loading: true,
      finished: false,
      refreshing: false,
      current: 1,
      size: 10,
      contractguid: '',
      catch: {},
      list: [],
      tabKey: '累计'
    };
  },
  mounted() {},
  created() {
    let { contractguid } = this.$route.query;
    let { id } = getUrlParams();
    if (!contractguid) {
      contractguid = id;
    }
    this._getVisaStatisticsByid(contractguid);
    let params = {
      contractguid: contractguid,
      current: this.current,
      size: this.size
    };
    this.contractguid = contractguid;
    this._getVisaListByid(params);
  },
  methods: {
    _getVisaStatisticsByid(contractguid) {
      this.$api.getVisaStatisticsByid({ contractguid }).then(res => {
        let { status, body } = res;
        if (status) {
          this.body = body;
        }
      });
    },
    chooseAllOrMonth(data) {
      this.tabKey = data == '累计' ? '累计' : '';
    },
    _getVisaListByid(params) {
      let { current, contractguid, size } = this;
      params = { current, size, contractguid, ...params };
      this.$api.getVisaListByid(params).then(res => {
        let { status, body } = res;
        let { records } = body;
        if (status) {
          this.loading = false;
          this.refreshing = false;
          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    onLoad() {
      this.current++;
      this._getVisaListByid({});
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-visa-detail-container {
  position: relative;
  // background: #efefef;
  margin-top: 10px;
  z-index: 9;
  /deep/ .van-cell {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0px;
    overflow: hidden;
    color: #323233;
    font-size: 0.28rem;
    line-height: 1;
    background-color: transparent;
    margin-bottom: 10px;
  }
  .visa-details-container {
    background: transparent;
    margin-bottom: 10px;
  }
  .top {
    height: 166px;
    border-bottom: 1px solid #efefef;
    width: 100%;
    display: flex;
    div:nth-child(1) {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 20px;
      position: relative;
      span:nth-child(1) {
        color: #36c392;
        font-size: 24px;
      }
      span:nth-child(2) {
        margin: 10px 0px 20px 0px;
        color: #000;
        font-size: 32px;
        font-weight: bold;
      }
      span:nth-child(3) {
        color: #666;
        font-size: 24px;
      }
    }
    div:nth-child(1)::after {
      content: '  ';
      width: 1px;
      height: 52px;
      background-color: #f1f1f1;
      margin: 0 auto;
      display: block;
      position: absolute;
      right: 0px;
      top: 74px;
    }
    div:nth-child(2) {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 56px;
      position: relative;
      span:nth-child(2) {
        margin-bottom: 20px;
        color: #000;
        font-size: 32px;
        font-weight: bold;
      }
      span:nth-child(3) {
        color: #666;
        font-size: 24px;
      }
    }
    div:nth-child(2)::after {
      content: '  ';
      width: 1px;
      height: 52px;
      background-color: #f1f1f1;
      margin: 0 auto;
      display: block;
      position: absolute;
      right: 0px;
      top: 74px;
    }
  }

  .bottom {
    height: 166px;
    width: 100%;
    display: flex;
    div:nth-child(1) {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 20px;
      position: relative;
      span:nth-child(1) {
        color: #36c392;
        font-size: 24px;
      }
      span:nth-child(2) {
        margin: 10px 0px 20px 0px;
        color: #000;
        font-size: 32px;
        font-weight: bold;
      }
      span:nth-child(3) {
        color: #666;
        font-size: 24px;
      }
    }
    div:nth-child(1)::after {
      content: '  ';
      width: 1px;
      height: 52px;
      background-color: #f1f1f1;
      margin: 0 auto;
      display: block;
      position: absolute;
      right: 0px;
      top: 74px;
    }
    div:nth-child(2),
    div:nth-child(3) {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 56px;
      position: relative;
      span:nth-child(2) {
        margin-bottom: 20px;
        color: #000;
        font-size: 32px;
        font-weight: bold;
      }
      span:nth-child(3) {
        color: #666;
        font-size: 24px;
      }
    }
    div:nth-child(2)::after {
      content: '  ';
      width: 1px;
      height: 52px;
      background-color: #f1f1f1;
      margin: 0 auto;
      display: block;
      position: absolute;
      right: 0px;
      top: 74px;
    }
  }
  .visa-list-content {
    margin-top: 10px;
    background: transparent;
  }
}
</style>
